export default __webpack_public_path__ + "static/media/mama_kinder.9a357fd1.png";